document.addEventListener("DOMContentLoaded", function() {

  var accordionCircles = document.querySelectorAll('.accordion-circles');
  var numberAccordionCircles = accordionCircles.length;

  for (let i = 0; i < numberAccordionCircles; i++) {

    /**
     * Enable the slider.
     */
    (function(accordion){

      let items = accordion.querySelectorAll('.accordion-circles__item');

      for (let i = 0; i < items.length; i++ ) {
        items[i].addEventListener('click', accordionClick);
      }

    })(accordionCircles[i]);

    function accordionClick(event) {

      let target = event.target;
      let targetParent = event.target.parentElement;

      let items = targetParent.querySelectorAll('.accordion-circles__item');

      // If clicked item is the active one.
      if (event.target.classList.contains('accordion-circles__item--active')) {

        // Find all the items active or hidden and reset.
        for( let i = 0; i < items.length; i++ ) {
          items[i].classList.remove('accordion-circles__item--active', 'accordion-circles__item--hide');
        }

      } else {

        // Activate the current item and hide others.
        event.target.classList.add('accordion-circles__item--active');

        for( let i = 0; i < items.length; i++ ) {
          if (!items[i].classList.contains('accordion-circles__item--active')) {
            items[i].classList.add('accordion-circles__item--hide')
          }
        }
      }
    }
  }

});